<template>
	<component :is="comp" />
</template>

<script>
export default {
	name: "ServiceHall",
	props: {
		renderComponent: {
			type: Promise,
		},
	},
	data() {
		return {
			comp: () => this.renderComponent
		}
	},
	methods: {}
}
</script>
